export default "__VITE_ASSET__DVgwK1WV__"